module.exports = __webpack_public_path__ + "img/Hair-Volume-Chart0.2e2b995f.jpg";